







import { Vue, Component } from "vue-property-decorator";
import { IImport } from "@/models/imports";

@Component({
  components: {
    "import-logs-table": () =>
      import("@/components/app/admin/imports/importLogsTable.vue")
  }
})
export default class AdminImportLogsView extends Vue {
  public importId: IImport["id"] = this.$route.params.importId;
}
